import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";

interface TextMessageListItemSkeletonProps {
  index: number;
}

export const TextMessageListItemSkeleton = ({
  index,
}: TextMessageListItemSkeletonProps) => (
  <Stack align="start" gap={1} className="w-full px-3 py-2.5">
    <Stack direction="row" align="center" gap={2}>
      <Skeleton className="h-4 w-32" />
      <Skeleton className="h-4 w-20" />
    </Stack>
    <Skeleton className={cn("h-4 w-2/3", { "w-full": index % 2 === 0 })} />
  </Stack>
);
